const form4 = {
  formId4: "new-user-form4",
  formField4: {
    allocationActivity: {
      name: "allocationActivity",
      label: "[01a] Hoạt động phân bổ: Đơn vị phụ thuộc kinh doanh dịch vụ viễn thông cước trả sau",
      type: "text",
    },
    quarter: {
      name: "quarter",
      label: "[01b] Kỳ tính thuế: Quý",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập quý",
    },
    year: {
      name: "year",
      label: "Năm",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập năm",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    }
  },
};

export default form4;
